module.exports = __webpack_public_path__ + "static/media/funeralHomeCertificate.6a2faf48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/funeralHomeCertificate.png
// module id = 198
// module chunks = 0